module.exports = "./assets/images/avatar-5.svg";